import { convertToTimeFormat, DateConverter } from "@/constants";
import { JobJustification } from "@/types/hiring-justification.types";
import React from "react";
import { FaCheck } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { HiOutlinePencilAlt } from "react-icons/hi";

const JobJustificationActivity: React.FC<{ job: JobJustification }> = ({
	job,
}) => {
	return (
		<div className="flex flex-col gap-6">
			{job.cfo_approved && job.cfo_approved_at ? (
				<div className="flex gap-4">
					<div className="bg-green-100 p-2 rounded-lg self-start">
						<FaCheck className="text-green-500" />
					</div>
					<div>
						<h5 className="text-green-600 font-medium">Approved by CFO</h5>
						<p className="text-sm mt-2">CFO Remarks: {job.cfo_approval_note}</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.cfo_approved_on
						)} at ${convertToTimeFormat(job.cfo_approved_at)}`}</small>
					</div>
				</div>
			) : job.cfo_rejected && job.cfo_rejected_at ? (
				<div className="flex gap-4">
					<div className="bg-red-100 p-2 rounded-lg self-start">
						<FaXmark className="text-red-500" />
					</div>
					<div>
						<h5 className="text-red-600 font-medium">Disapproved by CFO</h5>
						<p className="text-sm mt-2">CFO Remarks: {job.cfo_rejected_note}</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.cfo_rejected_on
						)} at ${convertToTimeFormat(job.cfo_rejected_at)}`}</small>
					</div>
				</div>
			) : null}
			{job.hr_partner_approved && job.hr_partner_approved_at ? (
				<div className="flex gap-4">
					<div className="bg-green-100 p-2 rounded-lg self-start">
						<FaCheck className="text-green-500" />
					</div>
					<div>
						<h5 className="text-green-600 font-medium">Approved by HR Partner</h5>
						<p className="text-sm mt-2">
							HR Partner Remarks: {job.hr_partner_approval_note}
						</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.hr_partner_approved_on
						)} at ${convertToTimeFormat(job.hr_partner_approved_at)}`}</small>
					</div>
				</div>
			) : job.hr_partner_rejected && job.hr_partner_rejected_at ? (
				<div className="flex gap-4">
					<div className="bg-red-100 p-2 rounded-lg self-start">
						<FaXmark className="text-red-500" />
					</div>
					<div>
						<h5 className="text-red-600 font-medium">Disapproved by HR Partner</h5>
						<p className="text-sm mt-2">
							HR Partner Remarks: {job.hr_partner_rejected_note}
						</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.hr_partner_rejected_on
						)} at ${convertToTimeFormat(job.hr_partner_rejected_at)}`}</small>
					</div>
				</div>
			) : null}
			{job.hr_manager_approved && job.hr_manager_approved_at ? (
				<div className="flex gap-4">
					<div className="bg-green-100 p-2 rounded-lg self-start">
						<FaCheck className="text-green-500" />
					</div>
					<div>
						<h5 className="text-green-600 font-medium">Approved by HR Manager</h5>
						<p className="text-sm mt-2">
							HR Manager Remarks: {job.hr_manager_approval_note}
						</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.hr_manager_approved_on
						)} at ${convertToTimeFormat(job.hr_manager_approved_at)}`}</small>
					</div>
				</div>
			) : job.hr_manager_rejected && job.hr_manager_rejected_at ? (
				<div className="flex gap-4">
					<div className="bg-red-100 p-2 rounded-lg self-start">
						<FaXmark className="text-red-500" />
					</div>
					<div>
						<h5 className="text-red-600 font-medium">Disapproved by HR Manager</h5>
						<p className="text-sm mt-2">
							HR Manager Remarks: {job.hr_manager_rejected_note}
						</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.hr_manager_rejected_on
						)} at ${convertToTimeFormat(job.hr_manager_rejected_at)}`}</small>
					</div>
				</div>
			) : null}
			{job.finance_partner_approved && job.finance_partner_approved_at ? (
				<div className="flex gap-4">
					<div className="bg-green-100 p-2 rounded-lg self-start">
						<FaCheck className="text-green-500" />
					</div>
					<div>
						<h5 className="text-green-600 font-medium">
							Approved by Finance Partner
						</h5>
						<p className="text-sm mt-2">
							Finance Partner Remarks: {job.finance_partner_approval_note}
						</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.finance_partner_approved_on
						)} at ${convertToTimeFormat(job.finance_partner_approved_at)}`}</small>
					</div>
				</div>
			) : job.finance_partner_rejected && job.finance_partner_rejected_at ? (
				<div className="flex gap-4">
					<div className="bg-red-100 p-2 rounded-lg self-start">
						<FaXmark className="text-red-500" />
					</div>
					<div>
						<h5 className="text-red-600 font-medium">
							Disapproved by Finance Partner
						</h5>
						<p className="text-sm mt-2">
							Finance Partner Remarks: {job.finance_partner_rejected_note}
						</p>
						<small className="font-light text-zinc-600">{`${DateConverter(
							job.finance_partner_rejected_on
						)} at ${convertToTimeFormat(job.finance_partner_rejected_at)}`}</small>
					</div>
				</div>
			) : (
				<div className="flex gap-4">
					<div className="bg-purple-100 p-2 rounded-lg self-start">
						<HiOutlinePencilAlt className="text-purple-500" />
					</div>
					<div>
						<h5 className="text-purple-600 font-medium">Awaiting Approval</h5>
					</div>
				</div>
			)}
		</div>
	);
};

export default JobJustificationActivity;
